import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostBinding, Input } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Observable } from 'rxjs';
import { ScrollContainerComponent } from '../../common/components/scroll.container/scroll.container.component';
import { FilterMultiComponent, FilterObject } from '../../common/filter';
import {
  ListOption,
  ScrollableListComponentBase,
} from '../../common/list.component.base';
import { DELETED, WebUtils } from '../../common/utils';
import { AccessUtils, TAgentContent, TLocation } from '../../core/entities';
import { SiteFormatMixin } from '../../thinkdesks/site.format.mixin';
import { TAgent } from '../../thinkdesks/thinkdesks.entities';
import { AgentContentAddDialogComponent } from './agent.content.add.dialog';
import { AgentContentEditDialogComponent } from './agent.content.edit.dialog';

class _Base extends ScrollableListComponentBase<TAgentContent> {}

@Component({
  selector: 'app-agent-content-list',
  templateUrl: './agent.content.list.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FilterMultiComponent,
    ScrollContainerComponent,
    FontAwesomeModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatDialogModule,
    MatToolbarModule,
  ],
})
export class AgentContentListComponent extends SiteFormatMixin(_Base) {
  _common = _common;
  @HostBinding('class') css = 'max-height';

  filterObject = new FilterObject();
  //   status = new FilterMulti();

  //   type = new FilterMulti();

  @Input()
  location: TLocation;

  @Input()
  agent: TAgent;

  displayedColumns: string[] = ['filename', 'controls'];

  constructor(
    override http: HttpClient,
    override elRef: ElementRef,
    private dialog: MatDialog,
    override snackBar: MatSnackBar
  ) {
    super(http, snackBar, elRef);
    // this.pageSort = 'seq';
    // this.pageSortDir = 'asc';
  }

  override createRequest(options: ListOption): Observable<Object> {
    let query = {
      location: WebUtils.objId(this.location),
      agent: WebUtils.objId(this.agent),
    } as any;

    Object.assign(query, this.filterObject.query());

    const url = this._listModifyUrl(`/api/agent-content/list`, {}, options);
    return this.http.post(url, query);
  }
  override ngOnInit() {
    super.ngOnInit();
    // this.filterObject.add('type', this.type);
    // this.filterObject.add('status', this.status);
  }
  override listFixList(list: TAgentContent[]) {
    for (let o of list) AccessUtils.fixAgentContent(o);
  }

  add() {
    const ref = this.dialog.open(AgentContentAddDialogComponent, {
      data: {
        location: this.location,
        agent: this.agent,
      },
    });
    ref.afterClosed().subscribe((result) => {
      if (result) {
        for (let o of result) this._addToList(o);
      }
    });
  }

  override selectObject(o: TAgentContent) {
    const dialogRef = this.dialog.open(AgentContentEditDialogComponent, {
      data: {
        objectId: o.id,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == DELETED) {
        this._removeFromList(o);
      } else if (result) {
        Object.assign(o, result);
      }
    });
  }
}
